/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";

import { Card, GoBack, DashboardIntro } from "../../../component/Component";

import { HiOutlineDocument } from "react-icons/hi";
import { VscFileSubmodule } from "react-icons/vsc";
import { BsBook, BsPeople } from "react-icons/bs";
import { GrAttraction, GrRestaurant } from "react-icons/gr";
import {
  MdShop,
  MdMusicNote,
  MdOutlineMuseum,
  MdOutlineNightlight,
  MdOutlineHotelClass,
  MdOutlineFoodBank,
  MdOutlineFormatPaint,
  MdOutlineMapsHomeWork,
} from "react-icons/md";
import { SiHotelsdotcom } from "react-icons/si";
import { AiOutlineShopping } from "react-icons/ai";
import { BiCameraMovie } from "react-icons/bi";
import { GiTheater, GiBallerinaShoes } from "react-icons/gi";

import {
  pushLevel,
  getSingleCountryDashboard,
} from "../../../../../middlewares/sysNavigation/SysNavigation";
import { useCountryContext } from "../../../../../context/country/countryContext/CountryContext";
import { addOneLevel } from "../../../../../middlewares/breadCrumb/BreadCrumb";
import { useAdminContext } from "../../../../../context/admin/context/AdminContext";
import { getType } from "../../contentStats/helper";
import { _TYPES_ } from "../../../../doseeData/utils/types";

const regionCountriesRoute = "/countries";

const ICONS = {
  "first level": <MdOutlineMapsHomeWork />,
  "second level": <MdOutlineMapsHomeWork />,
  "third level": <MdOutlineMapsHomeWork />,
  "fourth level": <MdOutlineMapsHomeWork />,
  events: <VscFileSubmodule />,
  attractions: <GrAttraction />,
  restaurants: <GrRestaurant />,
  "best of africa": <MdOutlineHotelClass />,
  music: <MdMusicNote />,
  news: <BsBook />,
  safaris: <MdOutlineMuseum />,
  "tour packages": <GrAttraction />,
  cinema: <BiCameraMovie />,
  museums: <MdOutlineMuseum />,
  "night life": <MdOutlineNightlight />,
  hotels: <SiHotelsdotcom />,
  classes: <MdOutlineHotelClass />,
  shopping: <AiOutlineShopping />,
  food: <MdOutlineFoodBank />,
  books: <BsBook />,
  neighborhoods: <BsPeople />,
  arts: <MdOutlineFormatPaint />,
  dance: <GiBallerinaShoes />,
  theaters: <GiTheater />,
  "city guides": <GrAttraction />,
  parties: <BsBook />,
  "things to do": <HiOutlineDocument />,
  "tips and advice": <BsBook />,
  ministries: <MdOutlineMapsHomeWork />,
  movies: <GiTheater />,
  "getting around": <MdOutlineMapsHomeWork />,
  products: <MdShop />,
};

const CountryDashboardComponent = () => {
  const { country_id } = useParams();
  const { sysAdmin, setSingleAdmin } = useAdminContext();
  const { countryStats, fetchCountryStats } = useCountryContext();

  // UI-only filters (do not change navigation/data logic)
  const [category, setCategory] = useState("All"); // All | Levels | Content
  const [query, setQuery] = useState("");

  useEffect(() => {
    if (!countryStats) fetchCountryStats(country_id);
  }, [countryStats]);

  const List = [
    { name: "First Level", quantity: countryStats ? countryStats?.first_level : "-", route: "/levels/first" },
    { name: "Second Level", quantity: countryStats ? countryStats?.second_level : "-", route: "/levels/second" },
    { name: "Third Level", quantity: countryStats ? countryStats?.third_level : "-", route: "/levels/third" },
    { name: "Fourth Level", quantity: countryStats ? countryStats?.fourth_level : "-", route: "/levels/fourth" },

    { name: "events", quantity: countryStats ? countryStats?.event : "-", route: "/data/event", key: _TYPES_.EVENT },
    { name: "attractions", quantity: countryStats ? countryStats?.attraction : "-", route: "/data/attraction", key: _TYPES_.ATTRACTION },
    { name: "restaurants", quantity: countryStats ? countryStats?.restaurant : "-", route: "/data/restaurant", key: _TYPES_.RESTAURANT },
    { name: "best of africa", quantity: countryStats ? countryStats?.best_of_africa : "-", route: "/data/bestofafrica", key: _TYPES_.BESTOFAFRICA },
    { name: "music", quantity: countryStats ? countryStats?.music : "-", route: "/data/music", key: _TYPES_.MUSIC },
    { name: "news", quantity: countryStats ? countryStats?.news : "-", route: "/data/news", key: _TYPES_.NEWS },
    { name: "safaris", quantity: countryStats ? countryStats?.safari : "-", route: "/data/safari", key: _TYPES_.SAFARI },
    { name: "tour packages", quantity: countryStats ? countryStats?.tour_package : "-", route: "/data/tour/package", key: _TYPES_.TOURPACKAGE },
    { name: "cinema", quantity: countryStats ? countryStats?.cinema : "-", route: "/data/cinema", key: _TYPES_.CINEMA },
    { name: "museums", quantity: countryStats ? countryStats?.museum : "-", route: "/data/museum", key: _TYPES_.MUSEUM },
    { name: "night life", quantity: countryStats ? countryStats?.nightlife : "-", route: "/data/nightlife", key: _TYPES_.NIGHTLIFE },
    { name: "hotels", quantity: countryStats ? countryStats?.hotel : "-", route: "/data/hotel", key: _TYPES_.HOTEL },
    { name: "classes", quantity: countryStats ? countryStats?.class : "-", route: "/data/class", key: _TYPES_.CLASSES },
    { name: "shopping", quantity: countryStats ? countryStats?.shopping : "-", route: "/data/shopping", key: _TYPES_.SHOPPING },
    { name: "food", quantity: countryStats ? countryStats?.food : "-", route: "/data/food", key: _TYPES_.FOOD },
    { name: "books", quantity: countryStats ? countryStats?.book : "-", route: "/data/book", key: _TYPES_.BOOK },
    { name: "neighborhoods", quantity: countryStats ? countryStats?.neighborhood : "-", route: "/data/neighborhood", key: _TYPES_.NEIGHBORHOOD },
    { name: "arts", quantity: countryStats ? countryStats?.art : "-", route: "/data/art", key: _TYPES_.ART },
    { name: "dance", quantity: countryStats ? countryStats?.dance : "-", route: "/data/dance", key: _TYPES_.DANCE },
    { name: "theaters", quantity: countryStats ? countryStats?.theater : "-", route: "/data/theater", key: _TYPES_.THEATER },
    { name: "City Guides", quantity: countryStats ? countryStats?.city_guide : "-", route: "/data/city/guide", key: _TYPES_.CITYGUIDE },
    { name: "Parties", quantity: countryStats ? countryStats?.party : "-", route: "/data/party", key: _TYPES_.PARTY },
    { name: "Things To Do", quantity: countryStats ? countryStats?.things_to_do : "-", route: "/data/things/todo", key: _TYPES_.THINGSTODO },
    { name: "Tips And Advice", quantity: countryStats ? countryStats?.tips_and_advice : "-", route: "/data/tips/advice", key: _TYPES_.TIPSANDADVICE },
    { name: "Ministries", quantity: countryStats ? countryStats?.ministry : "-", route: "/data/ministry", key: _TYPES_.MINISTRY },
    { name: "Movies", quantity: countryStats ? countryStats?.movie : "-", route: "/data/movie", key: _TYPES_.MOVIE },
    { name: "Getting Around", quantity: countryStats ? countryStats?.getting_around : "-", route: "/data/get/around", key: _TYPES_.GETTINGAROUND },
    { name: "Products", quantity: countryStats ? countryStats?.product : "-", route: "/data/product", key: _TYPES_.PRODUCT },
  ];

  // UI categorization
  const isLevel = (n) =>
    ["first level", "second level", "third level", "fourth level"].includes(n.toLowerCase());

  const filtered = useMemo(() => {
    const q = String(query || "").toLowerCase();
    return List.filter((item) => {
      const n = String(item.name).toLowerCase();
      const byCategory =
        category === "All" ? true : category === "Levels" ? isLevel(n) : !isLevel(n);
      const byQuery = !q || n.includes(q);
      return byCategory && byQuery;
    });
  }, [List, category, query]);

  const totalCards = filtered.length;

  return (
    <div className="overflow-y-auto p-3 lg:p-4 h-full rounded-b-xl bg-gray-50 pb-5">
      <GoBack props={{ route: regionCountriesRoute }} />

      {/* Header / Intro */}
      <div className="mx-auto mb-4 mt-2 max-w-7xl">
        <div className="rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="flex flex-col gap-4 p-4 md:flex-row md:items-center md:justify-between">
            <div className="flex items-center gap-3">
              <div>
                <h2 className="text-sm font-semibold tracking-tight text-gray-900">
                  Country Dashboard
                </h2>
                <p className="mt-1 text-[11px] text-gray-600">
                  Manage hierarchical levels and rich content types for this country.
                </p>
              </div>
              <span className="hidden md:inline-flex h-6 items-center rounded-full bg-gray-100 px-2 text-[10px] font-semibold text-gray-700">
                {totalCards} {totalCards === 1 ? "item" : "items"}
              </span>
            </div>

            {/* Filters */}
            <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
              <div className="flex gap-1">
                {["All", "Levels", "Content"].map((c) => (
                  <button
                    key={c}
                    onClick={() => setCategory(c)}
                    className={`rounded-full px-3 py-1 text-[11px] font-semibold transition ${category === c
                        ? "bg-gray-900 text-white"
                        : "border border-gray-200 bg-white text-gray-700 hover:bg-gray-50"
                      }`}
                  >
                    {c}
                  </button>
                ))}
              </div>
              <div className="relative sm:ml-1">
                <input
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="Filter cards (e.g., 'hotel', 'news')"
                  className="w-full rounded-lg border border-gray-200 bg-white p-2.5 pr-8 text-xs focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-200"
                />
                {query ? (
                  <button
                    type="button"
                    aria-label="Clear"
                    onClick={() => setQuery("")}
                    className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  >
                    ×
                  </button>
                ) : null}
              </div>
            </div>
          </div>
          <div className="h-[2px] w-full bg-gradient-to-r from-emerald-500 via-amber-500 to-purple-500 opacity-20" />
        </div>

        {/* Country name intro */}
        <div className="flex flex-row justify-center items-center mt-4">
          <DashboardIntro
            props={{ intro: "Country", name: getSingleCountryDashboard() }}
          />
        </div>
      </div>

      {/* Cards */}
      <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-8 gap-4 items-center selection:text-white selection:bg-blue-900 mb-5 mt-2">
        {filtered.length === 0 ? (
          <div className="col-span-full">
            <div className="rounded-xl border border-dashed border-gray-200 bg-white p-8 text-center text-xs text-gray-600 shadow-sm">
              No matches found. Adjust filters or try a different keyword.
            </div>
          </div>
        ) : null}

        {filtered.map((card, index) => {
          const normal = String(card.name).toLowerCase();
          const icon = ICONS[normal] || <MdOutlineMapsHomeWork />;
          return (
            <Link
              to={card?.route}
              key={`${card?.name}-${index}`}
              onClick={() => {
                // original navigation logic (unchanged)
                if (
                  ![
                    "regions",
                    "countries",
                    "First Level",
                    "Second Level",
                    "Third Level",
                    "Fourth Level",
                  ].includes(card?.name)
                ) {
                  setSingleAdmin({
                    ids: [sysAdmin?.admin_id],
                    type: getType({ field: card?.key }),
                    route: `/country/dashboard/${country_id}`,
                  });
                  addOneLevel({
                    id: 0,
                    name: `${sysAdmin?.first_name} ${sysAdmin?.last_name}`,
                    route: "/levels/first",
                    level: "",
                    country_id: 0,
                    data: {
                      data: {
                        name: "",
                        country_id: 0,
                        first_level_id: 0,
                        second_level_id: 0,
                        third_level_id: 0,
                        fourth_level_id: 0,
                        level: "",
                      },
                    },
                  });
                  pushLevel({
                    level: {
                      id: 0,
                      name: "",
                      level: "All",
                      route: "/levels/first",
                      data: null,
                    },
                  });
                }
              }}
            >
              <div className="transition-transform duration-150 ease-out hover:-translate-y-0.5">
                <Card
                  card={{
                    name: card.name,
                    quantity: card.quantity,
                    icon,
                  }}
                />
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default CountryDashboardComponent;
